import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  recuperarAluno: function(usuario) {
    return Vue.http.post('/api/login/recuperaraluno', usuario);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/recuperar-senha-aluno/servico.js